import { ComponentStore } from '@ngrx/component-store';
import { map, filter } from 'rxjs';
import { QuestionType } from '../models/questionType.model';

export interface scrollDetails {
    position: number;
    heightBoard?: number;
    heightBoardEdit?: number;
}
export interface DragState {
    readonly isDrag: boolean;
    readonly dragType?: QuestionType | null;
    readonly sortDragId?: number;
    readonly placeDragId?: number;
    readonly isChanged: boolean;
    readonly isValid: boolean;
    readonly scroll?: scrollDetails;
    readonly focusId?: number;
    readonly dragContainer: number;
    readonly goToBottom: boolean;
    readonly goToTop: boolean;
    readonly indexToAddToCollection?: number;
    readonly addFollowUpQuestion?: { questionId: number, optionItemGuid: string, type: QuestionType };
    readonly indexToDuplicateStep?: number;
    readonly deleteFolloesQuestion?: { optionGuid: string, questionIdes: number[] };
    readonly indexToSaveList?: number;
    readonly doScreanImage?: boolean;
    readonly addingStepNow?:  boolean;
    readonly clickStartedInCenter?: boolean;
    readonly apiExposureField?: { index: number, isEditMode: boolean };
    readonly isFilterField?: { index: number, isEditMode: boolean };
    readonly autoFillField?: { index: number, isEditMode: boolean };

}

export class DragStore extends ComponentStore<DragState> {
    constructor() {
        super({
            isChanged: false,
            isValid: true,
            isDrag: false,
            scroll: {
                position: 0,
                heightBoard: 280,
                heightBoardEdit: 20,
            },
            dragContainer: 1,
            goToBottom: false,
            goToTop: false,
        });
    }
    readonly isChanged$ = this.select(({ isChanged }) => isChanged);
    readonly isValid$ = this.select(({ isValid }) => isValid);
    readonly isDrag$ = this.select(({ isDrag }) => isDrag);
    readonly focusId$ = this.select(({ focusId }) => focusId);
    // readonly dragType$ = this.select(({ dragType }) => dragType);
    readonly dragTypeId$ = this.select(({ dragType }) => dragType?.id);
    // readonly sortDragId$ = this.select(({ sortDragId }) => sortDragId);
    // readonly placeDragId$ = this.select(({ placeDragId }) => placeDragId);
    // readonly isEnterDrag$ = this.select(({placeDragId})=>  placeDragId==20);
    readonly scrollPosition$ = this.select(({ scroll }) => scroll?.position);
    readonly clickStartedInCenter$ = this.select(({ clickStartedInCenter }) => clickStartedInCenter);
    // readonly dragContainer$ = this.select(({ dragContainer }) => dragContainer);
    readonly heightBoard$ = this.select(({ scroll }) => scroll).pipe
        (
            filter(s => s != undefined)
            , map(s => (s!.heightBoard ?? 0) > (s!.heightBoardEdit ?? 0) ? '0px' : `${(s!.heightBoardEdit ?? 0) - (s!.heightBoard ?? 0)}px`)
        )
    readonly heightBoardEdit$ = this.select(({ scroll }) => scroll).pipe
        (
            filter(s => s != undefined)
            , map(s => (s!.heightBoardEdit ?? 0) > (s!.heightBoard ?? 0) ? '0px' : `${(s!.heightBoard ?? 0) - (s!.heightBoardEdit ?? 0)}px`)
        )
    readonly goToBottomEvent$ = this.select(({ goToBottom }) => goToBottom);
    readonly goToTopEvent$ = this.select(({ goToTop }) => goToTop);
    readonly indexToAddToCollection$ = this.select(({ indexToAddToCollection }) => indexToAddToCollection);
    readonly apiExposureField$ = this.select(({ apiExposureField }) => apiExposureField);
    readonly isFilterField$ = this.select(({ isFilterField }) => isFilterField);
    readonly autoFillField$ = this.select(({ autoFillField }) => autoFillField);

    readonly addFollowUpQuestion$ = this.select(({ addFollowUpQuestion }) => addFollowUpQuestion);
    readonly deleteFolloesQuestion$ = this.select(({ deleteFolloesQuestion }) => deleteFolloesQuestion);
    readonly indexToDuplicateStep$ = this.select(({ indexToDuplicateStep }) => indexToDuplicateStep);
    readonly indexToSaveList$ = this.select(({ indexToSaveList }) => indexToSaveList);
    readonly doScreanImage$ = this.select(({ doScreanImage }) => doScreanImage);
    readonly addingStepNow$ = this.select(({ addingStepNow }) => addingStepNow);

    readonly addToCollection = this.updater((state, index: number | undefined) => ({
        ...state,
        indexToAddToCollection: index
    }));
    readonly updateAddingStepNow = this.updater((state, addingStepNow?: boolean | undefined) => ({
        ...state,
        addingStepNow
    }));
    readonly addFollowUpQuestion = this.updater((state, detailsOfFollowUp: { questionId: number, optionItemGuid: string, type: QuestionType } | undefined

    ) => ({
        ...state,
        addFollowUpQuestion: detailsOfFollowUp
    }));
    readonly deleteFollowQuestionsByIds = this.updater((state, detailsOfFollowQuestionToDelete: { optionGuid: string, questionIdes: number[] } | undefined

    ) => ({
        ...state,
        deleteFolloesQuestion: detailsOfFollowQuestionToDelete
    }));
    readonly duplicateStep = this.updater((state, index: number | undefined) => ({
        ...state,
        indexToDuplicateStep: index
    }));
    readonly saveList = this.updater((state, index: number | undefined) => ({
        ...state,
        indexToSaveList: index
    }));
    readonly updatIsChanges = this.updater((state, isChanges: boolean) => ({
        ...state,
        isChanges: isChanges
    }));
    readonly updatValid = this.updater((state, isValid: boolean) => ({
        ...state,
        isValid: isValid
    }));
    readonly updatDragEvent = this.updater((state, isDrag: boolean) => ({
        ...state,
        isDrag
    }));
    readonly updatSortId = this.updater((state, i: number) => ({
        ...state,
        sortDragId: i
    }));
    readonly updatPlaceId = this.updater((state, i: number) => ({
        ...state,
        placeDragId: i
    }));
    readonly updateDoScreenImage = this.updater((state, isDo: boolean) => ({
        ...state,
        doScreanImage: isDo
    }));
    readonly updatFocusId = this.updater((state, i: number) => (
        {
            ...state,
            focusId: i
        }));
    readonly resetFocusId = this.updater((state) => (
        {
            ...state,
            focusId: undefined
        }));
    readonly onCenterMouseDown = this.updater((state, isClickStartedInCenter: boolean) => (
        {
            ...state,
            clickStartedInCenter: isClickStartedInCenter
        }));
    readonly updatDragContainer = this.updater((state, i: number) => ({
        ...state,
        dragContainer: i
    }));
    readonly updatDragType = this.updater((state, type: QuestionType | null) => ({
        ...state,
        dragType: type
    }));
    readonly updateScroll = this.updater((state, position: number) => ({
        ...state,
        scroll: { ...state.scroll, position }
    }));
    readonly updateHeightBoard = this.updater((state, height: number) => ({
        ...state,
        scroll: { position: 0, ...state.scroll, heightBoard: height }
    }));
    readonly updateHeightBoardEdit = this.updater((state, height: number) => ({
        ...state,
        scroll: { position: 0, ...state.scroll, heightBoardEdit: height }
    }));
    readonly openAndCloseCollectionQuestions = this.updater((state, isOpen: boolean) => ({
        ...state,
        isOpen
    }));
    readonly goToBottom = this.updater((state, event: boolean) => ({
        ...state,
        goToBottom: event
    }));
    readonly goToTop = this.updater((state, event: boolean) => ({
        ...state,
        goToTop: event
    }));
    readonly setApiExposureField = this.updater((state, data: { index: number, isEditMode: boolean } | undefined) => ({
        ...state,
        apiExposureField: data
    }));
    readonly setUnauthorizedFilterField = this.updater((state, data: { index: number, isEditMode: boolean } | undefined) => ({
        ...state,
        isFilterField: data
    }));
    readonly setAutoFillField = this.updater((state, data: { index: number, isEditMode: boolean } | undefined) => ({
        ...state,
        autoFillField: data
    }));
}